<template>
  <van-action-sheet
    class="cost-entry-box"
    :closeable="false"
    :close-on-click-overlay="false"
    v-model="show"
    :title="data.title"
    @closed="close"
  >
    <div class="form-box scroll-box">
      <van-form
        ref="form"
        validate-first
        :show-error-message="false"
      >
        <div
          class="form-item"
        >
          <template v-for="(item, index) in data.extraProduct">
            <van-row
              :key="index"
              class="form-item-box"
              gutter="12"
              type="flex"
              align="center"
            >
              <van-col span="12">
                <van-field
                  name="name"
                  class="textarea-box"
                  v-model="item.name"
                  placeholder="请选择项目"
                  right-icon="arrow-down"
                  :rules="[
                    { required: true, message: '请选择项目' }
                  ]"
                  readonly
                  @click="showSelectExtraProductBox(index)"
                />
              </van-col>
              <van-col span="8">
                <van-field
                  name="value"
                  class="textarea-box"
                  v-model="item.value"
                  placeholder="请输入数量"
                  :rules="[
                    { required: true, message: '请输入数量' }
                  ]"
                />
              </van-col>
              <van-col span="4">
                <div class="delete-btn">
                  <van-button
                    icon="delete-o"
                    color="#FF8A59"
                    @click="detele(index)"
                  />
                </div>
              </van-col>
            </van-row>
          </template>
        </div>
        <div
          class="form-item"
        >
          <van-button
            class="add-btn"
            type="default"
            block
            plain
            icon="plus"
            @click="add"
          />
        </div>
      </van-form>
    </div>
    <div class="btn-box">
      <van-row gutter="17">
        <van-col span="12">
          <van-button
            type="default"
            block
            plain
            @click="cancel"
          >取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="info"
            block
            @click="confirm"
          >保存</van-button>
        </van-col>
      </van-row>
    </div>
    <!-- 增值产品选择器弹出层 -->
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
    >
      <!--  -->
      <van-picker
        title=""
        show-toolbar
        :columns="extraProductList"
        value-key="name"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </van-action-sheet>
</template>

<script>
import {
  saveExtra
} from '@/common/apiGeneral.js';
import {
  getExtraProductList
} from '@/common/apiPaic.js';
function initData() {
  return {
    title: '提示',
    extraProduct: [],
    extraParam: null,
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: '取消',
    confirmButtonText: '确认'
  };
}
import { cloneDeep } from 'lodash';
export default {
  name: 'ExtraProductBox',
  data() {
    return {
      show: false,
      data: initData(),
      extraProductList: [],
      currentIndex: -1,
      showPicker: false
    };
  },
  methods: {
    open(data) {
      console.log('data: ', data);
      data && (this.data = { ...this.data, ...cloneDeep(data) });
      console.log('this.data:', this.data);
      if (this.data.extraProduct.length === 0) {
        this.add();
      }
      this.show = true;
      this.getExtraProductList();
    },
    close() {
      this.show = false;
      this.data = initData();
    },
    async confirm() {
      const result = await this.validate();
      console.log(result);
      if (!result) {
        return;
      }
      await this.saveExtra();
    },
    cancel() {
      this.data.cancelCallback && this.data.cancelCallback.apply(this);
      this.close();
    },
    add() {
      this.data.extraProduct.push({
        code: null,
        desc: null,
        name: null,
        skuValueCode: null,
        title: null,
        value: 1
      });
    },
    detele(index) {
      this.data.extraProduct.splice(index, 1);
    },
    showSelectExtraProductBox(index) {
      this.currentIndex = index;
      this.showPicker = true;
    },
    onConfirm(value) {
      let current = this.data.extraProduct[this.currentIndex];
      current = {
        ...value,
        value: current.value
      };
      this.data.extraProduct.splice(this.currentIndex, 1, current);
      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false;
    },
    async validate() {
      if (!this.$refs.form) {
        return true;
      }
      try {
        await this.$refs.form.validate();
        return true;
      } catch (err) {
        console.log(err);
        this.$toast(err[0].message);
        return false;
      }
    },
    async getExtraProductList() {
      try {
        const data = await getExtraProductList(this.data.extraParam);
        if (data) {
          this.extraProductList = data || [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveExtra(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '保存中...',
          forbidClick: true
        });
      }
      try {
        const extraInfo = this.data.extraProduct;
        await saveExtra({
          ...this.data.extraParam,
          extraInfo
        });
        this.$toast('保存成功');

        this.data.confirmCallback && this.data.confirmCallback.call(this);
        this.close();
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cost-entry-box ::v-deep{
  .van-action-sheet__header{
    padding: 14px 16px 13px;

    text-align: center;

    color: #383838;
    border-bottom: 1px solid rgba(230,230,230,1);

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
  }
  .form-box{
    &.scroll-box{
      max-height: 40vh;
      overflow-y: auto;
    }
    .form-item{

      padding: 0 16px;
      .textarea-box {
        padding: 8px 10px 7px;

        border-radius: 4px;

        &.van-field--min-height .van-field__control{
          min-height: 42px;
        }

        &.input-box {
          height: 36px;
        }
      }
      .form-item-box {
        margin: 16px 0;
      }

      .delete-btn{
        display: flex;
        .van-button.van-button--normal{
          height: 38px;
          padding: 0 6px;

          border-radius: 6px;

          font-size: 20px;
        }
      }

      .add-btn{
        height: 38px;

        color: #909090;
        border: 1px dashed #c8c8c8;
        margin-top: 16px;
      }
    }
    .form-label{
      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }
    .form-tips{
      color: #999999;

      font-family: PingFangSC-Regular;
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
    }
  }
  .btn-box{
    padding: 16px;
    .van-button{
      height: 40px;
      padding: 9px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--default{
        color: #646464;
        border: 1px solid rgba(200,200,200,1);
        background: #FFFFFF;
      }

      &.van-button--info{
        color: #FFFFFF;
        border: 1px solid #3399FF;
        background: #3399FF;
      }
    }
  }
}
</style>
